var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Video",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Video",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.4v5.198a.4.4 0 00.61.34l4.203-2.605a.4.4 0 000-.68L6.61 5.06A.4.4 0 006 5.4z",
    shapeRendering: "geometricPrecision"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3v10a1 1 0 001 1h12a1 1 0 001-1V3a1 1 0 00-1-1H2a1 1 0 00-1 1zm12 9H3V4h10v8z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgFeaturedVideoIcon;